<div class="container">
    <div class="card" [@showUpCollection]="(forecastService.weather$ | async)?.length">
        <app-weather-card [weather]="weather" *ngFor="let weather of forecastService.weather$ | async">
        </app-weather-card>
    </div>
</div>
